@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";

// .main {}

.mainHeaderContainer {
  display: flex;
  justify-content: space-between;

  .editActivitiesText {
    padding-left: $space-25;

    & h1 {
      font-size: $font-size-h18;
      color: $White;
      font-weight: $font-weight-semibold;
    }
  }
}

.dialogContainer {
  padding: $space-25 $space-35;
  display: flex;
  flex-direction: column;
  width: 350px;
  gap: $space-9;

  @media screen and (max-width: 415px) {
    width: max-content;
    width: 80vw;
  }

  .headerContainer {
    padding-top: $space-5;
    display: flex;
    justify-content: space-between;

    & img {
      width: 30px;
    }

    & h1 {
      font-family: $zv-font-heading--font-primary;
      font-size: $font-size-h20;
      color: $zv-text-primary--Black-Variant2;
      font-weight: $font-weight-semibold;
    }
  }

  .detailsContainer {
    margin-top: $space-15;
    display: flex;
    flex-direction: column;

    & h1 {
      font-family: $font-primary;
      font-size: $font-size-h15;
      color: $zv-text-primary--Black-Variant2;
      font-weight: $font-weight-semibold;

      & span {
        color: $zv-error--Primary-ElectricViolet;
      }
    }

    .radioGroup {
      margin-top: $space-20;
      display: flex;
      gap: $space-10;
      flex-direction: column;

      .radioLabel {
        & p {
          user-select: none;
          /* Prevents text selection */
          -webkit-user-select: none;
          -ms-user-select: none;
          font-family: $font-primary !important;
          font-size: $font-size-h14;
          color: $zv-text-primary--Black-Variant2;
          padding-left: $space-10;
          // border: 1px solid green;
        }
      }

      .radioContainer {
        display: flex;
        flex-direction: column;
        gap: $space-5;

        .textAreaContainer {
          display: flex;
          flex-direction: column;

          & p {
            align-self: flex-end;
            font-weight: $font-weight-semibold;
            font-size: $font-size-h8;
            margin-top: $space-4;
            padding-right: $space-5;
          }
        }

        .textArea {
          margin-left: $space-40;
          border-radius: $border-radius-xs;
          padding: $space-10;
          color: $zv-text-primary--Black-Variant2;
          border-color: $zv-border--slate-66;
          resize: none;

          &::placeholder {
            color: $zv-text-muted--slate-66;
          }

          &:focus {
            outline: none;
            border-color: $Brand-Primary;
            cursor: text;
          }
        }
      }
    }
  }
}

.buttonContainer {
  display: flex;
  justify-content: center;
  gap: $space-20;
  padding-top: $space-25;

  .continueBtn {
    text-transform: initial;
    font-size: $font-size-h14;
    border-radius: $border-radius-33;
    // padding: 4px 35px;
    font-weight: $font-weight-semibold;
    font-family: $font-primary;
    background-color: $Neutral-Darkest;
    color: $White;
    // padding: 5px 45px;
    padding: $space-3 $space-35;

    &:hover {
      background-color: $Neutral-Darkest;
    }

    &:focus {
      background-color: $Neutral-Darkest;
    }

    &:disabled {
      background-color: $zv-disabled--gray-62;
    }

    &.activeBtn {
      opacity: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
